'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { Motion } from '@/components/motion'
import { homeSizeStyles } from '@/features/home/utils/home-size'
import { cn } from '@/utils/styles/cn'

export const HomeBenefits = () => {
    const t = useTranslations()

    const translations = useMemo((): Record<'title' | 'description', string>[] => {
        return [
            {
                title: t('home.benefits.first.title'),
                description: t('home.benefits.first.description'),
            },
            {
                title: t('home.benefits.second.title'),
                description: t('home.benefits.second.description'),
            },
            {
                title: t('home.benefits.third.title'),
                description: t('home.benefits.third.description'),
            },
        ]
    }, [t])

    return (
        <div
            className={cn(
                'flex md:flex-row flex-col items-top justify-between gap-[20px] px-8',
                homeSizeStyles
            )}
        >
            {translations.map((translation, i) => {
                const imageSrc = `/_images/home/benefits/benefits-${i + 1}.svg`

                return (
                    <Motion
                        index={i}
                        baseDelay={0.12}
                        indexDelay={0.15}
                        y={40}
                        key={'client-home-benefits' + translation.title}
                        className="px-4"
                    >
                        <Image
                            priority
                            alt="Small illustration"
                            src={imageSrc}
                            height={40}
                            width={40}
                            className="mb-2"
                        />

                        <h2 className="mb-2">{translation.title}</h2>
                        <p className="text-gray-500">{translation.description}</p>
                    </Motion>
                )
            })}
        </div>
    )
}
